import { CategoricalBandTickedXAxis, CategoricalBandTickedYAxis, TickedTopXAxis, TickedXAxis, TickedYAxis } from '@opengov/data-viz';
import classnames from 'classnames2';
import React from 'react';
import styles from './Axis.scss';

var getDefaultStyle = function getDefaultStyle(componentName) {
  switch (componentName) {
    case 'Axis.Y':
      return defaultYAxisStyles;

    case 'Axis.X':
      return defaultXAxisStyle;

    case 'Axis.Band.X':
      return defaultXBandAxisStyle;

    case 'Axis.Band.Y':
      return defaultYBandAxisStyle;

    case 'Axis.Top.X':
      return defaultXTopAxisStyle;

    default:
      return null;
  }
};

var defaultXBandAxisStyle = {
  axisLabel: styles.axisLabel,
  axisLine: styles.axisLine,
  axisTick: styles.axisTick,
  zeroLine: styles.zeroLine,
  domain: styles.domain,
  text: styles.text,
  tick: styles.tick,
  tickLine: styles.tickLine
};
var defaultYBandAxisStyle = {
  axisLabel: styles.axisLabelAnchorEnd,
  axisLine: styles.axisLine,
  axisTick: styles.axisTick,
  zeroLine: styles.zeroLine,
  domain: styles.domain,
  text: styles.text,
  tick: styles.tickHorizontal,
  tickLine: styles.tickLine
};
var defaultXAxisStyle = {
  yaxis: styles.axisLabel,
  text: styles.text,
  tick: styles.tick,
  axisLine: styles.axisLine,
  axisTick: styles.axisTick
};
var defaultYAxisStyles = {
  axisLine: styles.axisLine,
  axisTick: styles.axisTick,
  text: styles.text,
  tick: styles.tick,
  yaxis: styles.axisLabel
};
var defaultXTopAxisStyle = {
  yaxis: styles.axisLabel,
  text: styles.text,
  tick: styles.tick,
  axisLine: styles.axisLine,
  axisTick: styles.axisTick
};
export var createAxis = function createAxis(componentName, dataTest) {
  var AxisComponent = function AxisComponent(_ref) {
    var approximateNumberOfTicks = _ref.approximateNumberOfTicks,
        _ref$style = _ref.style,
        style = _ref$style === void 0 ? getDefaultStyle(componentName) : _ref$style,
        tickLabelFormatter = _ref.tickLabelFormatter,
        xScale = _ref.xScale,
        xTickLabelWidth = _ref.xTickLabelWidth,
        dimmed = _ref.dimmed,
        xTickLabelHeight = _ref.xTickLabelHeight,
        yScale = _ref.yScale;
    var styleToUse = dimmed ? Object.keys(style).reduce(function (stylesObject, styleKey) {
      stylesObject[styleKey] = classnames(style[styleKey], styles.dim);
      return stylesObject;
    }, {}) : style;

    switch (componentName) {
      case 'Axis.Y':
        return React.createElement(TickedYAxis, {
          formatter: tickLabelFormatter,
          approximateNumberOfTicks: approximateNumberOfTicks,
          scale: yScale,
          style: styleToUse
        });

      case 'Axis.X':
        return React.createElement(TickedXAxis, {
          formatter: tickLabelFormatter,
          approximateNumberOfTicks: approximateNumberOfTicks,
          style: styleToUse,
          xScale: xScale,
          yScale: yScale
        });

      case 'Axis.Band.X':
        return React.createElement(CategoricalBandTickedXAxis, {
          formatter: tickLabelFormatter,
          labelWidth: xTickLabelWidth,
          style: styleToUse,
          xScale: xScale,
          yScale: yScale
        });

      case 'Axis.Band.Y':
        return React.createElement(CategoricalBandTickedYAxis, {
          formatter: tickLabelFormatter,
          style: styleToUse,
          xScale: xScale,
          yScale: yScale
        });

      case 'Axis.Top.X':
        return React.createElement(TickedTopXAxis, {
          approximateNumberOfTicks: approximateNumberOfTicks,
          formatter: tickLabelFormatter,
          labelHeight: xTickLabelHeight,
          style: styleToUse,
          xScale: xScale,
          yScale: yScale
        });

      default:
        return null;
    }
  };

  AxisComponent.displayName = componentName;
  return AxisComponent;
};
var AxisTypes;

(function (AxisTypes) {
  AxisTypes["X"] = "Axis.X";
  AxisTypes["Y"] = "Axis.Y";
  AxisTypes["BandX"] = "Axis.Band.X";
  AxisTypes["BandY"] = "Axis.Band.Y";
  AxisTypes["TopX"] = "Axis.Top.X";
})(AxisTypes || (AxisTypes = {}));

export var Axis = {
  Band: {
    X: createAxis(AxisTypes.BandX, 'x-band-axis'),
    Y: createAxis(AxisTypes.BandY, 'y-band-axis')
  },
  X: createAxis(AxisTypes.X, 'x-axis'),
  Y: createAxis(AxisTypes.Y, 'y-axis'),
  Top: {
    X: createAxis(AxisTypes.TopX, 'x-top-axis')
  }
};